import Vue from 'vue';
import objectFitImages from 'object-fit-images';
import AOS from 'aos';

import headerState from './modules/headerState';
import initHpSliderBanner from './modules/initHpSliderBanner';
import initTestSlider from './modules/initTestSlider';
import initSliderImgLegends from './modules/initSliderImgLegends';
import cookieScroll from './modules/cookieScroll';

import HpProjectSlider from './components/HpProjectSlider/HpProjectSlider';
import ProjectList from './components/ProjectList';
import DecCookies from './components/DecCookies';
import initHpTextSliderBanner from './modules/initHpTextSliderBanner';


import { debounce } from "./utils/functions";

document.addEventListener('DOMContentLoaded', () => {
    objectFitImages();
    AOS.init();

    new headerState();
    new initHpSliderBanner();
    new initTestSlider();
    new initSliderImgLegends();
    new cookieScroll();
    new initHpTextSliderBanner();
    
});

const app = new Vue({
    components: {
        HpProjectSlider,
        ProjectList,
        DecCookies,
    },
    el: '.vue-container',
    data() {
        return {
            error: false,
            clientWidth: document.documentElement.clientWidth,
        }
    },
    mounted() {
       window.addEventListener('resize', this.resizeWindow);
    },
    methods: {
        resizeWindow: debounce(function (){
            this.resolutionVersion();
        }, 250),

        resolutionVersion() {
            this.clientWidth = document.documentElement.clientWidth;
        },

    }

});